export enum InputDisplay {
  Inline = 'inline',
  InlineSpaced = 'inline-spaced',
  InlineReversed = 'inline-reversed',
  Block = 'block',
}
